import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
  Box,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { cancelApiIntergration } from "../../../functions/cancelApi/cancelApi";
import { gql } from "@apollo/client";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/loading";

const cancelleaverequest = gql`
  mutation cancelleaverequest($id: ID!) {
    CancelLeaveRequest(id: $id) {
      success
      message
      error
    }
  }
`;
function ViewScreen_LeaveData() {
  const [employeeData, setemployeeData] = useState([]);
  console.log("employeeData",employeeData);
  
  const [id, setID] = useState(null);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const { circleLoading, setCirleLoading } = useLoading();
  const navigate = useNavigate();
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);

    if (id) {
      getemployeedata(id);
    }
  }, []);

  const getemployeedata = async (id) => {
    const query = `
    query GetLeaveById($id: String!) {
 
  getLeaveById(id: $id) {
 
    data {
 
      id
 
      reason
 
      totalDays 
      leaveFrom  
      leaveTill
      user{
        id
        firstName
        lastName
      }
      status
      teamApproval
      hrApproval
      teamleaderId
      leaveType{
        id
        name
      }

 
      primaryDor{
 
        firstName
        lastName
 
      }
 
 
      secondaryDor{
 
        firstName
        lastName
 
      } 
      attachment
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
 
      followUpTasks
 
    }
 
    success
 
    error
 
    message
 
  }
 
}
  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const leaveDatass = response.data.data.getLeaveById?.data[0];
      console.log("leaveDatass:", leaveDatass);

      setemployeeData(leaveDatass);
    } catch (error) {
      console.log("ReponseError:", error);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/apply-leave");
  };

  const handleCancelLeave = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to cancel your Leave.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        const { status } = await cancelApiIntergration(cancelleaverequest, id);
        setCirleLoading(false);

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Cancel successfully",
          showConfirmButton: false,
          timer: 4500,
        }).then(() => {
          navigate("/apply-leave");
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const today = new Date();

  const formattedDate =
    today.getFullYear() +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(today.getDate()).padStart(2, "0");

  const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const today = new Date();
      const hours = today.getHours() % 12 || 12;
      const minutes = String(today.getMinutes()).padStart(2, "0");
      const ampm = today.getHours() >= 12 ? "PM" : "AM";

      setTime(`${hours}:${minutes}${ampm}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  const checkdate = formattedDate <= employeeData.leaveFrom;
  console.log("checkdate",checkdate);
  
  const checktime = time >= "3:00PM";
  console.log("checktime",checktime);
  

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 2, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold" textAlign="center">
                Leave Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <Grid container spacing={1} justifyContent="center">
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.user?.firstName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave Type:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveType?.name}
                  </span>
                </Typography>

                <Typography variant="h6">
                  <strong>Total Days:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.totalDays}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {" "}
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}{" "}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.reason}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave From:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveFrom}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave Till:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveTill}
                  </span>
                </Typography>
             
              </Stack>
            </Grid>
          </Grid>
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
              {
                employeeData?.status?.toLowerCase() !== "cancelled" &&
                employeeData?.status?.toLowerCase() !== "rejected" && (
                  <MaterialButton
                    variant="contained"
                    color="error"
                    onClick={() => handleCancelLeave()}
                    sx={{ marginLeft: "10px" }}
                  >
                    Cancel Leave
                  </MaterialButton>
                 
                )}
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default ViewScreen_LeaveData;
